import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SettlementServiceService } from '../../../../services/raintree/Transmission/settlement-service.service';
import { LoaderComponent } from '../../../../common-component/loader/loader.component';
import { error } from 'console';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-bill-details',
  standalone: true,
  imports: [MatIconModule, LoaderComponent],
  templateUrl: './bill-details.component.html',
  styleUrl: './bill-details.component.scss',
})
export class BillDetailsComponent implements OnInit {
  bills: any[] = [];
  isLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<BillDetailsComponent>,
    private settlementService: SettlementServiceService,private toastr:ToastrService,
  ) {}

  ngOnInit(): void {
    this.getAllBills()
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getAllBills() {
    this.isLoading = true;
    const params = {
      mandirCode: this.data.mandirCode,
      fy: this.data.fy,
    };
    console.log('passing params', params);

    this.settlementService.getMandirBills(params).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res) {
          this.bills = res.data;
        }
        // this.toastr.success(res.message)
        console.log('data received from API for mandir bills:', res.data);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastr.error(err.message)
      }
    });
  }

  formatIndianCurrency(amount: string | number): string {
    const number = Number(amount);
    if (isNaN(number)||null) return '--';

    return (
      '₹ ' +
      number.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }
}
